import { render, staticRenderFns } from "./ProductTaxonomyId.vue?vue&type=template&id=4e60122c&"
import script from "./ProductTaxonomyId.vue?vue&type=script&lang=ts&"
export * from "./ProductTaxonomyId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports